export interface EjendomKoordinatPunkt {
    ejendomNr: number;
    latitude: number;
    longitude: number;
}

export interface NaermesteEjendom extends EjendomKoordinatPunkt {
    afstandMeter: number;
}

export function findNaermesteEjendomme(
    punkter: EjendomKoordinatPunkt[],
    placering: { latitude: number; longitude: number },
    antal: number,
    radiusMeter: number
): NaermesteEjendom[] {
    const bedste = new Map<number, NaermesteEjendom>();
    for (const punkt of punkter) {
        if (!Number.isFinite(punkt.ejendomNr) || punkt.ejendomNr <= 0) {
            continue;
        }
        if (!Number.isFinite(punkt.latitude) || !Number.isFinite(punkt.longitude)) {
            continue;
        }
        if (punkt.latitude === 0 && punkt.longitude === 0) {
            continue;
        }
        const meter = afstandMeter(placering.latitude, placering.longitude, punkt.latitude, punkt.longitude);
        if (!Number.isFinite(meter) || meter > radiusMeter) {
            continue;
        }
        const eksisterende = bedste.get(punkt.ejendomNr);
        if (!eksisterende || meter < eksisterende.afstandMeter) {
            bedste.set(punkt.ejendomNr, { ...punkt, afstandMeter: meter });
        }
    }
    return [...bedste.values()].sort((a, b) => a.afstandMeter - b.afstandMeter).slice(0, antal);
}

export function afstandMeter(lat1: number, lng1: number, lat2: number, lng2: number): number {
    const tilRad = Math.PI / 180;
    const dLat = (lat2 - lat1) * tilRad;
    const dLng = (lng2 - lng1) * tilRad;
    const a = Math.sin(dLat / 2) ** 2 + Math.cos(lat1 * tilRad) * Math.cos(lat2 * tilRad) * Math.sin(dLng / 2) ** 2;
    return 6371000 * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}

export function formatAfstand(meter: number | null | undefined): string {
    if (meter == null || !Number.isFinite(meter) || meter < 0) {
        return "";
    }
    if (meter < 1000) {
        return `${Math.round(meter)}m`;
    }
    const km = meter / 1000;
    if (km >= 10) {
        return `${Math.round(km)}km`;
    }
    return `${(Math.round(km * 10) / 10).toFixed(1).replace(".", ",")}km`;
}
